import type {MembershipExpandedCommon} from '../../../../api/membership';

import {membershipStore} from '../../../../api/membership';
import {logger} from '../../../../utils/logger';
import {AcceptRequestedMembershipsStrategy} from './AcceptRequestedMembershipsStrategy';

type Config = {
  memberships: MembershipExpandedCommon[];
};

export class AcceptIndividualRequestedMembershipsStrategy extends AcceptRequestedMembershipsStrategy {
  constructor(private readonly config: Config) {
    super();
  }

  async execute(): Promise<void> {
    logger.event('request_accept_confirmation_tap');

    const {memberships} = this.config;

    const readyToAcceptMemberships: MembershipExpandedCommon[] = [];
    const invalidMemberships: MembershipExpandedCommon[] = [];

    memberships.forEach(membership => {
      const lastEdition = membership.program.editions?.pop();

      if (membership.edition_id === lastEdition?._id) {
        readyToAcceptMemberships.push(membership);
      } else {
        invalidMemberships.push(membership);
      }
    });

    if (readyToAcceptMemberships.length) {
      await this.acceptValidMemberships(readyToAcceptMemberships);
    }

    if (invalidMemberships.length) {
      await this.decline(invalidMemberships);
    }

    logger.event('request_accept_success_view');
  }

  private async acceptValidMemberships(
    memberships: MembershipExpandedCommon[],
  ) {
    await membershipStore.coach.acceptBatch(
      memberships.map(entity => ({
        entity,
      })),
    );
  }
}
